// The app's one <audio> for link items (spec 2026-10-24: one audio player per client). The wall dock plays it
// locally, a link cast drives it from the server timeline; both through this element.
import { forwardRef, type AudioHTMLAttributes } from "react";

export interface AudioPlayerProps extends Omit<AudioHTMLAttributes<HTMLAudioElement>, "src"> {
  src: string | null | undefined;
  testId?: string;
}

/** No surface of its own (the card draws art and controls); `preload="auto"`, never autoPlay: callers play(). */
const AudioPlayer = forwardRef<HTMLAudioElement, AudioPlayerProps>(function AudioPlayer({ src, testId, ...rest }, ref) {
  return <audio ref={ref} data-testid={testId} src={src ?? undefined} preload="auto" {...rest} />;
});

export default AudioPlayer;
